import * as Yup from "yup";
import { minError, maxError } from "../utils";
export default ((t, isFonix) => {
  console.log(isFonix, 'isFonix YUP');
  return Yup.object().shape({
    amount: Yup.string().required(`${t.amount} ${t.required}`).matches(/^[0-9]+(\.[0-9]{1,2})?$/gm, `${t.amount} ${t.invalid}`),
    // password: isFonix
    //   ? Yup.string().notRequired()
    //   : Yup.string()
    //     .required(`${t.password} ${t.required}`)
    //     .min(4, minError(t.password, 4, t.minError, t.characters))
    //     .max(50, maxError(t.password, 50, t.maxError, t.characters)),
    password: Yup.string().test("isFonix", `${t.password} ${t.required}`, function (value, context) {
      return context.options.parent.isFonix ? true : value;
    }).test("min", minError(t.password, 4, t.minError, t.characters), function (value, context) {
      return context.options.parent.isFonix ? true : value?.length >= 4;
    }).test("max", maxError(t.password, 50, t.maxError, t.characters), function (value, context) {
      return context.options.parent.isFonix ? true : value?.length <= 50;
    })
  });
});